import React from 'react';
import './AccountButton.css';

/**
 * AccountButton - Persistent account navigation button displayed in the top-right corner
 * 
 * @param {Function} onClick - Callback when button is clicked (navigates to account page)
 */
function AccountButton({ onClick }) {
    return (
        <button 
            className="account-button" 
            onClick={onClick}
            aria-label="Account"
            title="Account Settings"
        >
            <img 
                src="/art/UserIcon.png" 
                alt="User Account" 
                className="account-icon"
            />
        </button>
    );
}

export default AccountButton;
